import NavbarMobile from "./NavbarMobile.vue";
import NavbarDesktop from "./NavbarDesktop.vue";
import BaseButton from "./BaseButton.vue";
import BaseLoading from "./BaseLoading.vue";
import InputSwitch from "./InputSwitch.vue";

export default {
  install(App) {
    App.component("v-navbar-mobile", NavbarMobile);
    App.component("v-navbar-desktop", NavbarDesktop);
    App.component("v-button", BaseButton);
    App.component("v-loading", BaseLoading);

    App.component("v-input-switch", InputSwitch);
  }
};
